import { travelData } from "../../state/travelData";
import * as eventTracker from "../../tracker/EventTracker";
import * as Board from "../board";

const formatFilters = function* (filters) {
	if (!filters) {
		return;
	}
	if (filters.board == Board.BREAKFAST) {
		yield "inkl. Frühstück";
	}
	if (filters.board == Board.HALF_BOARD) {
		yield "Halbpension";
	}
	if (filters.cancelation) {
		yield "kostenlos stornierbar";
	}
};

export const formatLabel = (dates, filters = null) =>
	[
		dates,
		`Gäste ${travelData.formattedRequestParameter.rooms}`,
		Array.from(formatFilters(filters)).join(", "),
	]
		.filter(entry => entry != "")
		.join(" | ");

export const formatAlternativeDatesAction = (hotel, arrival) => {
	const diff = (arrival - travelData.arrival) / (60 * 60 * 24 * 1000);
	const unit = Math.abs(diff) === 1 ? "Tag" : "Tage";
	const number = diff > 0 ? `+${diff}` : diff.toString();
	return `${number} ${unit} - ${hotel.id} | ${hotel.name} - Profil`;
};

/**
 * Track empty price request for a hotel
 *
 * @param {String} origin
 * @param {Object} hotel
 * @param {Array} filters
 */
export const trackNoPrices = (origin, hotel, filters = null) => {
	eventTracker.trackImpression(
		"Preisvergleich Kein Preis",
		`${origin}: ${hotel.id} | ${hotel.name}`,
		formatLabel(travelData.formattedRequestParameter.dates, filters),
	);
};
